(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koira-brand-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (v) => {
      const n = Number(String(v).replace(/[^0-9.]/g, ''));
      return Number.isFinite(n) && n > 0 ? '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
    };
    const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ESC[c]);
    const timers = new WeakMap();

    async function suggest(form, query) {
      const box = form.querySelector('[data-koira-suggest]');
      const list = form.querySelector('[data-koira-suggest-list]');
      const all = form.querySelector('[data-koira-suggest-all]');
      if (!box || !list) return 0;
      if (form.dataset.products !== 'true' || query.length < 2) { box.hidden = true; return 0; }
      const url = new URL(form.dataset.suggestUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', form.dataset.limit || '6');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      try {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        const data = await res.json();
        const input = form.querySelector('[data-koira-brand-search]');
        if (!input || input.value.trim() !== query) return 0; // ya escribió otra cosa
        const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        list.innerHTML = products.map((p) => {
          const img = (p.featured_image && p.featured_image.url) || p.image || '';
          const pic = img
            ? '<img src="' + esc(img) + (img.includes('?') ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">'
            : '<span class="koira-brands__suggest-ph"></span>';
          const price = money(p.price);
          return '<li><a class="koira-brands__suggest-item" href="' + esc(p.url) + '">' + pic
            + '<span class="koira-brands__suggest-text"><span>' + esc(p.title) + '</span><small>'
            + esc(p.vendor || '') + (price ? ' · ' + price : '') + '</small></span></a></li>';
        }).join('');
        if (all) all.textContent = (all.dataset.label || '').replace('«»', '«' + query + '»');
        box.hidden = products.length === 0;
        return products.length;
      } catch (e) {
        box.hidden = true;
        return 0;
      }
    }

    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-koira-brand-search]')) return;

      const root = input.closest('.koira-brands');
      if (!root) return;

      const query = input.value.trim().toLowerCase();
      let visible = 0;

      root.querySelectorAll('[data-brand-name]').forEach((item) => {
        const match = query === '' || item.dataset.brandName.includes(query);
        item.hidden = !match;
        if (match) visible++;
      });

      const empty = root.querySelector('[data-koira-brand-empty]');
      const form = input.closest('[data-koira-brand-form]');
      if (!form) { if (empty) empty.hidden = visible > 0; return; }
      if (empty) empty.hidden = true;
      clearTimeout(timers.get(form));
      timers.set(form, setTimeout(async () => {
        const found = await suggest(form, input.value.trim());
        if (empty) empty.hidden = visible > 0 || found > 0 || input.value.trim().length < 2;
      }, 250));
    });

    // Enter: si escribió una marca completa, va a esa marca; si no, a la búsqueda de productos
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-koira-brand-form]')) return;
      const input = form.querySelector('[data-koira-brand-search]');
      const query = ((input && input.value) || '').trim().toLowerCase();
      if (!query) { event.preventDefault(); return; }
      const root = form.closest('.koira-brands');
      const exact = root && [...root.querySelectorAll('[data-brand-name]')].find((li) => li.dataset.brandName === query);
      const link = exact && exact.querySelector('a');
      if (link) { event.preventDefault(); window.location.href = link.href; }
    });

    // cerrar las sugerencias al tocar fuera o con Esc
    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-koira-brand-form]').forEach((form) => {
        const box = form.querySelector('[data-koira-suggest]');
        if (box && !form.contains(event.target)) box.hidden = true;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-koira-suggest]').forEach((box) => { box.hidden = true; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koira-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koira-reviews-carousel')) {
    customElements.define(
      'koira-reviews-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.koira-reviews__list');
          this.items = [...this.querySelectorAll('.koira-reviews__card')];
          this.dots = [...this.querySelectorAll('.koira-reviews__dot')];
          this.arrows = [...this.querySelectorAll('.koira-reviews__arrow')];
          if (!this.track || !this.items.length) return;
          this.index = 0;

          this.arrows.forEach((btn) =>
            btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.dir)))
          );
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.settle);
            this.settle = setTimeout(() => {
              this.index = this.current();
              this.update();
            }, 120);
          }, { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }

        maxIndex() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const first = this.items[0].offsetLeft;
          const i = this.items.findIndex((item) => item.offsetLeft - first >= maxScroll - 4);
          return i === -1 ? this.items.length - 1 : i;
        }

        current() {
          const first = this.items[0].offsetLeft;
          const left = this.track.scrollLeft;
          if (left >= this.track.scrollWidth - this.track.clientWidth - 4) return this.maxIndex();
          let best = 0;
          let bestDist = Infinity;
          this.items.forEach((item, i) => {
            const dist = Math.abs(item.offsetLeft - first - left);
            if (dist < bestDist) {
              bestDist = dist;
              best = i;
            }
          });
          return best;
        }

        goTo(index) {
          const i = Math.max(0, Math.min(this.maxIndex(), index));
          this.index = i;
          this.track.scrollTo({ left: this.items[i].offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
          this.update();
        }

        update() {
          const max = this.maxIndex();
          if (this.index > max) this.index = max;
          this.dots.forEach((dot, d) => {
            dot.hidden = d > max;
            dot.setAttribute('aria-current', d === this.index ? 'true' : 'false');
          });
          if (this.arrows[0]) this.arrows[0].disabled = this.index <= 0;
          if (this.arrows[1]) this.arrows[1].disabled = this.index >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koira-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koira-routine-carousel')) {
    customElements.define(
      'koira-routine-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.koira-routine__steps');
          this.items = [...this.querySelectorAll('.koira-routine__step')];
          this.dots = [...this.querySelectorAll('.koira-routine__dot')];
          this.arrows = [...this.querySelectorAll('.koira-routine__arrow')];
          if (!this.track || !this.items.length) return;

          this.index = 0;
          this.arrows.forEach((btn) =>
            btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.dir)))
          );
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.settle);
            this.settle = setTimeout(() => {
              this.index = this.current();
              this.update();
            }, 120);
          }, { passive: true });
          this.update();
        }

        current() {
          if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4) {
            return this.index >= this.items.length - 2 ? this.index : this.items.length - 1;
          }
          const start = this.track.getBoundingClientRect().left;
          let best = 0;
          let bestDist = Infinity;
          this.items.forEach((item, i) => {
            const dist = Math.abs(item.getBoundingClientRect().left - start - 16);
            if (dist < bestDist) {
              bestDist = dist;
              best = i;
            }
          });
          return best;
        }

        goTo(index) {
          const i = Math.max(0, Math.min(this.items.length - 1, index));
          const item = this.items[i];
          this.index = i;
          this.update();
          this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
        }

        update() {
          const last = this.items.length - 1;
          this.dots.forEach((dot, d) => dot.setAttribute('aria-current', d === this.index ? 'true' : 'false'));
          if (this.arrows[0]) this.arrows[0].disabled = this.index <= 0;
          if (this.arrows[1]) this.arrows[1].disabled = this.index >= last;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koira-visit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koira-visit-carousel')) {
    customElements.define(
      'koira-visit-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.koira-visit__rlist');
          this.items = [...this.querySelectorAll('.koira-visit__review')];
          this.dots = [...this.querySelectorAll('.koira-visit__dot')];
          this.arrows = [...this.querySelectorAll('.koira-visit__arrow')];
          if (!this.track || !this.items.length) return;
          this.index = 0;
          this.arrows.forEach((btn) => btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.dir))));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.settle);
            this.settle = setTimeout(() => { this.index = this.current(); this.update(); }, 120);
          }, { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }
        maxIndex() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const first = this.items[0].offsetLeft;
          const i = this.items.findIndex((item) => item.offsetLeft - first >= maxScroll - 4);
          return i === -1 ? this.items.length - 1 : i;
        }
        current() {
          const first = this.items[0].offsetLeft;
          const left = this.track.scrollLeft;
          if (left >= this.track.scrollWidth - this.track.clientWidth - 4) return this.maxIndex();
          let best = 0, bestDist = Infinity;
          this.items.forEach((item, i) => {
            const dist = Math.abs(item.offsetLeft - first - left);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          return best;
        }
        goTo(index) {
          const i = Math.max(0, Math.min(this.maxIndex(), index));
          this.index = i;
          this.track.scrollTo({ left: this.items[i].offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
          this.update();
        }
        update() {
          const max = this.maxIndex();
          if (this.index > max) this.index = max;
          this.dots.forEach((dot, d) => { dot.hidden = d > max; dot.setAttribute('aria-current', d === this.index ? 'true' : 'false'); });
          if (this.arrows[0]) this.arrows[0].disabled = this.index <= 0;
          if (this.arrows[1]) this.arrows[1].disabled = this.index >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
